/**
 * Text utilities for safe display of API data.
 * Decodes HTML entities (e.g. &#x27;, &apos;) and normalizes smart quotes
 * that may come from the backend sanitizer or STT/LLM output.
 */
export function decodeHtmlEntities(value) {
  if (!value) return '';
  let decoded = String(value);
  for (let i = 0; i < 4; i += 1) {
    const next = decoded
      .replace(/&amp;/g, '&')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      // Numeric / hex angle brackets (some APIs/DB values use these instead of named entities)
      .replace(/&#60;/g, '<')
      .replace(/&#62;/g, '>')
      .replace(/&#x3c;/gi, '<')
      .replace(/&#x3e;/gi, '>')
      // Malformed entities without semicolon before comma/space/end (e.g. "&lt,&gt")
      .replace(/&lt(?=[,\s>]|$)/g, '<')
      .replace(/&gt(?=[,\s<]|$)/g, '>')
      .replace(/&quot;/g, '"')
      .replace(/&#x27;?/gi, "'")
      .replace(/&#39;?/g, "'")
      .replace(/&apos;?/gi, "'")
      .replace(/&#x2f;?/gi, '/')
      .replace(/\u2019/g, "'")  // right single quotation mark (smart apostrophe)
      .replace(/\u2018/g, "'"); // left single quotation mark
    if (next === decoded) break;
    decoded = next;
  }
  return decoded;
}

/** Decode entities and trim - use for editable/display text from API. */
export function safeDisplayText(value) {
  return decodeHtmlEntities(String(value ?? '')).trim();
}

/** Format meeting type name for display: strip trailing " (Standard)" if present. */
export function formatMeetingTypeDisplayName(name) {
  if (!name || typeof name !== 'string') return name ?? '';
  return decodeHtmlEntities(name).replace(/\s*\(Standard\)\s*$/i, '').trim() || name;
}
